import Vue from 'vue'

export const SET_USER = 'SET_USER';
export const SET_USER_OLD = 'SET_USER_OLD';

export default {
  state: {
    userList: [],
    oldUserList: [],
  },
  mutations: {
    [SET_USER](state, userList) {
      Vue.set(state, 'userList', userList)
    },
    [SET_USER_OLD](state, oldUserList) {
      Vue.set(state, 'oldUserList', oldUserList)
    },

  },
  actions: {
    [SET_USER]({commit}, userList) {
      commit(SET_USER, userList)
    },
    [SET_USER_OLD]({commit}, oldUserList) {
      commit(SET_USER_OLD, oldUserList)
    },

  }
}



// WEBPACK FOOTER //
// ./src/store/inviteUser.js